export default __webpack_public_path__ + "static/media/port.f4f9fa5f.png";